export const SIGNALR_CONNECTION_STATUS = {
  CONNECTING: 'connecting',
  CONNECTED: 'connected',
  RECONNECTING: 'reconnecting',
  DISCONNECTED: 'disconnected',
} as const;

export type SignalRConnectionStatus =
  (typeof SIGNALR_CONNECTION_STATUS)[keyof typeof SIGNALR_CONNECTION_STATUS];
